import { render, staticRenderFns } from "./PrivadoRow.vue?vue&type=template&id=19bb67e4"
import script from "./PrivadoRow.vue?vue&type=script&lang=js"
export * from "./PrivadoRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports